"use client";

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import { initGlobalWebSocket, closeGlobalWebSocket, globalWSManager } from '@/lib/websocket/global-manager';
import { getToken } from '@/lib/api';

// WebSocket提供者组件，用于全局管理WebSocket连接
export function WebSocketProvider({ children }: { children: React.ReactNode }) {
  const pathname = usePathname();

  useEffect(() => {
    // 完全异步初始化，不阻塞UI渲染
    const initWS = async () => {
    // 检查是否有token（用户已登录）
    const token = getToken();
    
    if (token && typeof window !== 'undefined') {
        // 使用 requestIdleCallback 或 setTimeout 确保不阻塞UI
        const scheduleInit = () => {
          if ('requestIdleCallback' in window) {
            requestIdleCallback(() => {
              console.log('[WebSocket提供者] 正在初始化全局WebSocket连接...');
              initGlobalWebSocket().catch(err => {
                console.warn('[WebSocket提供者] WebSocket连接初始化失败', err);
                // 如果连接失败，可能是token问题
                if (err.message && err.message.includes('token')) {
                  console.log('[WebSocket提供者] 检测到token问题，可能需要重新登录');
                }
              });
            }, { timeout: 2000 });
          } else {
            // 降级到 setTimeout，使用最小延迟
            setTimeout(() => {
              console.log('[WebSocket提供者] 正在初始化全局WebSocket连接...');
              initGlobalWebSocket().catch(err => {
                console.warn('[WebSocket提供者] WebSocket连接初始化失败', err);
                // 如果连接失败，可能是token问题
                if (err.message && err.message.includes('token')) {
                  console.log('[WebSocket提供者] 检测到token问题，可能需要重新登录');
                }
              });
            }, 100); // 稍微延迟一下，给登录状态检查时间
          }
        };

        // 等待下一帧，确保UI已渲染
        requestAnimationFrame(() => {
          scheduleInit();
        });
    } else {
        // 如果没有token，确保断开连接（异步执行）
        setTimeout(() => {
          closeGlobalWebSocket();
        }, 0);
      }
    };

    // 异步执行初始化
    initWS();
  }, [pathname]); // 当路径改变时重新检查

  // 监听页面可见性变化
  useEffect(() => {
    if (typeof window === 'undefined') return;

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        // 异步重连，不阻塞UI
        requestAnimationFrame(() => {
        const token = getToken();
          if (token && !globalWSManager.isConnected()) {
          console.log('[WebSocket提供者] 页面可见，尝试重新连接...');
            initGlobalWebSocket().catch(err => {
              console.error('[WebSocket提供者] 重新连接失败:', err);
            });
        }
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, []);

  // 在组件卸载时清理
  useEffect(() => {
    return () => {
      // 注意：这里不关闭连接，因为切换页面时应该保持连接
      // 只在用户登出时关闭
    };
  }, []);

  return <>{children}</>;
}






